import type { StoreApi } from "zustand";
import { create } from "zustand";
import { calculateOpenMap } from "./actions/utils/calculateOpenMap";
import type { ProjectUIActions } from "./projectUIActions";
import { createProjectUIActions } from "./projectUIActions";
import type { Node } from "interfaces/schemas";

export type ProjectUIStore = {
  openMap: Record<string, boolean> | null;
  actions: ProjectUIActions;
  initOpenMap: (tree: Node[] | null) => void;
  showProductPictures: boolean;
  redrawIndex: number;
  reset: () => void;
};

export const useProjectUIStore = create<ProjectUIStore>()(
  (set, get, api: StoreApi<ProjectUIStore>) => ({
    openMap: null,
    initOpenMap: (tree) => {
      if (!tree) {
        return;
      }
      const openMap = calculateOpenMap(tree);
      set({ openMap });
    },
    showProductPictures: true,
    redrawIndex: 0,
    actions: createProjectUIActions(set, get),
    reset: () => set(api.getInitialState()),
  }),
);

export const getOpenMap = () => useProjectUIStore.getState().openMap;
export const useShowProductPictures = () =>
  useProjectUIStore((state) => state.showProductPictures);
export const useProjectUIActions = () =>
  useProjectUIStore((state) => state.actions);
